// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/ats-surveillance-service.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/ats-surveillance-service/ats-surveillance-service.js';
import g1 from '../lessons/air-law/ats-surveillance-service/radar-vectoring-and-termination.js';

mount([g0, g1]);
